export default "__VITE_ASSET__26fcf33f__"